(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bv-craftsmanship"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bv-craftsmanship-video')) {
    customElements.define('bv-craftsmanship-video', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup) return;
        this.inView = false;
        this.userPaused = false;
        const onVisibility = () => this.syncPlayback();
        document.addEventListener('visibilitychange', onVisibility);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.15;
            this.syncPlayback();
          }, { threshold: [0, 0.15] });
          this.observer.observe(this);
        } else {
          this.inView = true;
          this.syncPlayback();
        }

        this.cleanup = () => {
          document.removeEventListener('visibilitychange', onVisibility);
          if (this.observer) this.observer.disconnect();
          if (this.video) {
            this.video.removeEventListener('pause', this.onPause);
            this.video.removeEventListener('play', this.onPlay);
            this.video.pause();
          }
        };
      }

      mountVideo() {
        if (this.video) return;
        const template = this.querySelector('template');
        if (!template) return;
        this.appendChild(template.content.cloneNode(true));
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.video.defaultMuted = true;
        this.video.muted = true;
        this.video.playsInline = true;
        this.video.setAttribute('aria-label', this.getAttribute('aria-label') || 'BONAVENTURA craftsmanship');
        this.onPause = () => {
          if (this.inView && !document.hidden && !this.video.ended) this.userPaused = true;
        };
        this.onPlay = () => {
          this.userPaused = false;
          if (!this.inView || document.hidden) this.video.pause();
        };
        this.video.addEventListener('pause', this.onPause);
        this.video.addEventListener('play', this.onPlay);
      }

      syncPlayback() {
        if (!this.inView || document.hidden) {
          if (this.video) this.video.pause();
          return;
        }
        this.mountVideo();
        if (!this.video || this.userPaused) return;
        const attempt = this.video.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(() => {
            // Autoplay may be blocked by the browser. Native controls remain available.
          });
        }
      }

      disconnectedCallback() {
        if (this.cleanup) this.cleanup();
        this.cleanup = null;
        // Fresh media avoids stale state when the theme editor reconnects this element.
        if (this.video) {
          this.video.removeAttribute('src');
          this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
          this.video.load();
          this.video.remove();
        }
        this.video = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
